<template>
	<div>
		<ForecastLine />
		<div class="row mt-3" v-if="weather.current">
			<div class="col-4 text-muted">
				<span>Right Now</span>
			</div>
			<div class="col-8">
				<span class='super-text'>{{weather.current.tempF}}&deg;</span>
				<span class="text-muted">Feels like {{weather.current.feelslikeF}}&deg;</span>
				<div>{{weather.current.humidity}}% humidity</div>
			</div>
		</div>
		<div class="row mt-3" v-if="weather.current">
			<div class="col-4 text-muted">
				Forecast
			</div>
			<div class="col-8">
				{{weather.current.weatherPrimary}}
			</div>
		</div>
		<div class="row mt-3" v-if="weather.alerts">
			<div class="col-4 text-muted">
				Alerts
			</div>
			<div class="col-8">
				<span class="text-success" v-if="weather.alerts.length == 0">No Alerts</span>
				<div v-else>
					<div class="text-danger" v-for="(item, index) in weather.alerts" :key="index">
						{{item.details.name}}
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-1" v-if="weather.day">
			<div class="col-4 text-muted py-2">
				Next 12 Hours
			</div>
			<div class="col-8">
				<div class="border-bottom py-2" v-for="(item, index) in weather.day" :key="index">
					<span class="text-left ml-2">{{moment.unix(item.timestamp).format("ha")}}</span>
					<span class="float-right mr-2">{{item.tempF}}</span>
				</div>
			</div>
		</div>

		<div id="mini-map" style="width: 100%; height: 266px;" class="shadow">	</div>
	</div>
</template>

<script>

	import {mapState} from 'vuex';
	import AerisWeather from '@aerisweather/javascript-sdk';
	import ForecastLine from './ForecastLine';

	export default {
		name: 'ForecastComplete',
		components: {ForecastLine},
		data() {
			return {
				aeris: null,
				weather_map: null,
				mini_map: null,
				mini_map_to: null
			}
		},
		watch: {
			mini_map() {
				this.setMiniMapLayers();
			},
			side_panel() {
				if (this.side_panel == 'forecast' && !this.mini_map) {
					this.setMiniMap();
				}
				// if (this.mini_map_to) clearInterval(this.mini_map_to);
				// this.mini_map_to = setInterval( () => {
				// 	this.mini_map.updateSize();
				// }, 1);
				// setTimeout(function () {
				// 	clearInterval(this.mini_map_to)
				// }, 450);
			}
		},
		computed: {
			...mapState([
				'weather',
				'location',
				'side_panel_open',
				'side_panel'
			])
		},
		mounted() {

		},
		methods: {
			setMiniMap() {
				this.aeris = new AerisWeather(this.$config.weather.access_id, this.$config.weather.secret_key);
				this.mini_map = new ol.Map({
					target: 'mini-map',
					layers: [
						new ol.layer.Tile({
							visible: true,
							preload: Infinity,
							title: 'Satellite',
							combine: false,
							type: 'base',
							source: new ol.source.BingMaps({
								key: 'AiGPlacWJqU2ue7htTeSa_zdIoFdPbpnwnwe4LFLSkcBBE5k2ZWGyl17ZLQCpM5e',
								imagerySet: 'Aerial',
								maxZoom: 19
							})
						})
					],
					view: new ol.View({
						center: ol.proj.fromLonLat([this.location.long, this.location.lat]),
						zoom: 6//this.location.zoom - 4
					}),
					interactions: [
						// new ol.interaction.DragRotate({condition: ol.events.condition.shiftKeyOnly}),
						// new ol.interaction.DragPan(),
						new ol.interaction.MouseWheelZoom(),
						// new ol.interaction.PinchZoom(),
						// new ol.interaction.PinchRotate(),
					],
					controls: [
					//	new ol.control.Zoom(),
					//	new ol.control.ScaleLine(),
					//	new ol.control.Rotate(),
					//	new ol.control.LayerSwitcher()
					],

				});


			},
			setMiniMapLayers() {
				this.aeris.views().then((views) => {
					 this.weather_map = new views.InteractiveMap(this.mini_map, {
						 layers: 'precip:50',
						//'fqpf-6h:50'
					 });
				});
			}
		},
	}
</script>

